import {Injectable, Type, ViewContainerRef} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

type DrawerContext = {
  hideCloseButton?: boolean;
  hideBackdrop?: boolean;
  hideScrollbar?: boolean;
  data?: unknown;
};
@Injectable({
  providedIn: 'root',
})
export class OphDrawerService {
  private drawerContent!: ViewContainerRef;
  private visibleSubject = new BehaviorSubject<boolean>(false);
  private drawerContext = new BehaviorSubject<DrawerContext>(null);
  drawerContext$ = this.drawerContext.asObservable();
  visible$ = this.visibleSubject.asObservable();

  setDrawerContent(viewContainerRef: ViewContainerRef): void {
    this.drawerContent = viewContainerRef;
  }

  setDrawerContext(context: DrawerContext) {
    this.drawerContext.next(context);
  }

  getDrawerContext(): DrawerContext {
    return this.drawerContext.getValue();
  }

  openDrawer(): void {
    this.visibleSubject.next(true);
  }

  closeDrawer(): void {
    this.visibleSubject.next(false);
    this.drawerContext.next(null);
  }

  loadComponent<T>(component: Type<T>, inputs?: unknown): void {
    if (!this.drawerContent) {
      console.error('Drawer content ViewContainerRef is not set.');
      return;
    }
    this.drawerContent.clear();
    const componentRef = this.drawerContent.createComponent(component);
    // Set input properties to the created component that will show inside the drawer
    if (inputs) {
      Object.keys(inputs).forEach(key => {
        componentRef.setInput(key, inputs[key]);
      });
    }
  }

  isDrawerVisible(): boolean {
    return this.visibleSubject.getValue();
  }
}
